import useFetchConfigs from "api/ConfigResource/useFetchConfigs";
import Admin2 from "layouts/Admin2";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import ConfigItem from "./ConfigItem";

const Configurations = () => {
	const { data: configs, isLoading } = useFetchConfigs();

	// console.log({ configs });

	if (isLoading) {
		return (
			<Admin2 fullWidth>
				<div className="flex flex-col justify-center items-center h-full w-full py-32">
					<AiOutlineLoading3Quarters
						size={40}
						className="animate-spin text-2xl mb-4 text-gray-500"
					/>
					<p className="text-gray-500 text-lg">Loading configurations...</p>
				</div>
			</Admin2>
		);
	}

	if (!configs || configs.length <= 0) {
		return (
			<Admin2 fullWidth>
				<div className="flex flex-col justify-center items-center h-full w-full py-32">
					<p className="text-gray-400 text-xl mb-2">No configurations found.</p>
					<p className="text-gray-500">
						Please check back later or contact support.
					</p>
				</div>
			</Admin2>
		);
	}

	return (
		<Admin2 fullWidth>
			<div className=" flex flex-col gap-2 max-w-5xl mx-auto mt-10 p-4 w-full">
				<div className="flex flex-col  gap-4 w-full mb-6">
					<h1 className="text-2xl font-extrabold text-green-800 tracking-tight">
						Configurations
					</h1>
					<p className="text-gray-500 text-base max-w-2xl font-light">
						Manage and review system configuration values. These settings
						control various aspects of the application. Changes may affect
						system behavior.
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full mt-2">
					{configs.map((config) => (
						<ConfigItem
							key={config.id}
							id={config.id}
							name={config.name}
							label={config.label}
							value={config.value}
							dataType={config.data_type}
						/>
					))}
				</div>
			</div>
		</Admin2>
	);
};

export default Configurations;
